import { EventEmitter, Directive, ChangeDetectorRef, ElementRef, NgZone, Input, Output, NgModule } from '@angular/core';
import stickybits from 'stickybits';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class StickybitsDirective {
    /**
     * @param {?} changeDetectorRef
     * @param {?} elementRef
     * @param {?} zone
     */
    constructor(changeDetectorRef, elementRef, zone) {
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this.zone = zone;
        this.isSticky = false;
        this.isStuck = false;
        this.parentClass = 'sticky-parent';
        this.stickyChangeClass = 'sticky--change';
        this.stickyClass = 'sticky';
        this.stuckClass = 'stucky';
        this.useStickyClasses = true;
        this.sticky = new EventEmitter();
        this.stuck = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.init();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.instance) {
            this.destroy();
            this.init();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy();
    }
    /**
     * @private
     * @return {?}
     */
    init() {
        /** @type {?} */
        const element = (/** @type {?} */ (this.elementRef.nativeElement));
        this.zone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            this.instance = this.initStickybits(element);
            this.cssClassObserver = this.initClassObserver(element);
        }));
    }
    /**
     * @private
     * @param {?} element
     * @return {?}
     */
    initStickybits(element) {
        return stickybits(element, {
            customStickyChangeNumber: this.stickyChangeNumber,
            noStyles: this.noStyles,
            stickyBitStickyOffset: this.stickyOffset,
            scrollEl: this.scrollEl,
            parentClass: this.parentClass,
            stickyClass: this.stickyClass,
            stuckClass: this.stuckClass,
            stickyChangeClass: this.stickyChangeClass,
            useStickyClasses: this.useStickyClasses,
            useFixed: this.useFixed,
            useGetBoundingClientRect: this.useGetBoundingClientRect,
            verticalPosition: this.verticalPosition,
        });
    }
    /**
     * @private
     * @param {?} element
     * @return {?}
     */
    initClassObserver(element) {
        /** @type {?} */
        const observer = new MutationObserver((/**
         * @param {?} mutations
         * @return {?}
         */
        mutations => {
            mutations
                .filter((/**
             * @param {?} mutation
             * @return {?}
             */
            mutation => mutation.oldValue !== element.classList.value))
                .forEach((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                let shouldDetectChanges = false;
                /** @type {?} */
                const hasStickyClass = element.classList.contains(this.stickyClass);
                if (hasStickyClass !== this.isSticky) {
                    this.isSticky = hasStickyClass;
                    this.sticky.emit(this.isSticky);
                    shouldDetectChanges = true;
                }
                /** @type {?} */
                const hasStuckClass = element.classList.contains(this.stuckClass);
                if (hasStuckClass !== this.isStuck) {
                    this.isStuck = hasStuckClass;
                    this.stuck.emit(this.isStuck);
                    shouldDetectChanges = true;
                }
                if (shouldDetectChanges) {
                    this.changeDetectorRef.detectChanges();
                }
            }));
        }));
        observer.observe(element, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class'],
        });
        return observer;
    }
    /**
     * @private
     * @return {?}
     */
    destroy() {
        this.instance.cleanup();
        this.instance = null;
        this.cssClassObserver.disconnect();
        this.cssClassObserver = null;
    }
}
StickybitsDirective.ɵfac = function StickybitsDirective_Factory(t) { return new (t || StickybitsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
StickybitsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StickybitsDirective, selectors: [["", "stickybits", ""]], inputs: { parentClass: "parentClass", stickyChangeClass: "stickyChangeClass", stickyClass: "stickyClass", stuckClass: "stuckClass", useStickyClasses: "useStickyClasses", noStyles: "noStyles", scrollEl: "scrollEl", stickyChangeNumber: "stickyChangeNumber", stickyOffset: "stickyOffset", useFixed: "useFixed", useGetBoundingClientRect: "useGetBoundingClientRect", verticalPosition: "verticalPosition" }, outputs: { sticky: "sticky", stuck: "stuck" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
StickybitsDirective.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: NgZone }
];
StickybitsDirective.propDecorators = {
    noStyles: [{ type: Input }],
    scrollEl: [{ type: Input }],
    parentClass: [{ type: Input }],
    stickyChangeClass: [{ type: Input }],
    stickyChangeNumber: [{ type: Input }],
    stickyClass: [{ type: Input }],
    stickyOffset: [{ type: Input }],
    stuckClass: [{ type: Input }],
    useFixed: [{ type: Input }],
    useGetBoundingClientRect: [{ type: Input }],
    useStickyClasses: [{ type: Input }],
    verticalPosition: [{ type: Input }],
    sticky: [{ type: Output }],
    stuck: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickybitsDirective, [{
        type: Directive,
        args: [{
                selector: '[stickybits]'
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { parentClass: [{
            type: Input
        }], stickyChangeClass: [{
            type: Input
        }], stickyClass: [{
            type: Input
        }], stuckClass: [{
            type: Input
        }], useStickyClasses: [{
            type: Input
        }], sticky: [{
            type: Output
        }], stuck: [{
            type: Output
        }], noStyles: [{
            type: Input
        }], scrollEl: [{
            type: Input
        }], stickyChangeNumber: [{
            type: Input
        }], stickyOffset: [{
            type: Input
        }], useFixed: [{
            type: Input
        }], useGetBoundingClientRect: [{
            type: Input
        }], verticalPosition: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StickybitsModule {
}
StickybitsModule.ɵfac = function StickybitsModule_Factory(t) { return new (t || StickybitsModule)(); };
StickybitsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: StickybitsModule });
StickybitsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickybitsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                exports: [StickybitsDirective],
                declarations: [StickybitsDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickybitsModule, { declarations: function () { return [StickybitsDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [StickybitsDirective]; } }); })();

export { StickybitsDirective, StickybitsModule };

//# sourceMappingURL=ngx-stickybits.js.map